var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('audio-player',{attrs:{"src":_vm.audioSrc,"time":_vm.aTime,"play":_vm.aPlayed,"volume":_vm.aVolume},on:{"timeupdate":function($event){_vm.currentATime = $event}}})}
var staticRenderFns = []

export { render, staticRenderFns }